import {
  SUBMIT_ANSWERS_REQUEST,
  SUBMIT_ANSWERS_SUCCESS,
  SUBMIT_ANSWERS_FAILURE
} from 'actions';

// eslint-disable-next-line default-param-last
function questionnaire(state = {
  isSubmittingAnswers: false,
  redirectUrl: '',
  data: { usPassport: undefined }
}, action) {
  switch (action.type) {
    case SUBMIT_ANSWERS_REQUEST:
      return {
        ...state,
        isSubmittingAnswers: action.isSubmittingAnswers,
        redirectUrl: action.redirectUrl
      };
    case SUBMIT_ANSWERS_SUCCESS:
      return {
        ...state,
        isSubmittingAnswers: action.isSubmittingAnswers,
        redirectUrl: action.redirectUrl
      };
    case SUBMIT_ANSWERS_FAILURE:
      return {
        ...state,
        isSubmittingAnswers: action.isSubmittingAnswers,
        redirectUrl: action.redirectUrl
      };
    default:
      return state;
  }
}

export default questionnaire;
